"use client";

import { Suspense } from "react";
import { usePathname } from "next/navigation";
import ArticleTemplate from "@/components/article/ArticleTemplate";

export default function Page() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "";

  return (
    <Suspense fallback={null}>
      <ArticleTemplate
        articleName={articleName}
        banner={`${process.env.IMAGE_DOMAIN}/delivery-brand/delivery-banner.png`}
      />
    </Suspense>
  );
}
